import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { IPdfViewerProps } from './document-viewer-modal.types';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Configure PDF.js worker - using Vite's ?url import suffix with .mjs extension
// Vite requires the ES module version (.mjs) for proper bundling
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const PdfViewer: React.FC<IPdfViewerProps> = ({ url, authorization }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageWidth, ] = useState<number>(600);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  // Configure file prop with authentication
  // If we have an authorization token (OAuth), use it in the header
  // Otherwise, requestToken should be in the URL query params
  const fileConfig = authorization
    ? {
        url,
        httpHeaders: {
          Authorization: authorization,
        },
      }
    : url; // If no authorization, just use URL (requestToken should be in query params)

  return (
    <div className="flex flex-col items-center w-full max-h-[80vh] overflow-y-auto">
      <Document
        file={fileConfig}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div className="flex items-center justify-center p-8">
            <div className="text-gray-500">Loading PDF...</div>
          </div>
        }
        error={
          <div className="flex items-center justify-center p-8">
            <div className="text-red-500">Failed to load PDF</div>
          </div>
        }
      >
        {numPages &&
          Array.from(new Array(numPages), (_, index) => (
            <div key={`page_${index + 1}`} className="mb-4">
              <Page
                pageNumber={index + 1}
                width={pageWidth}
                renderTextLayer={true}
                renderAnnotationLayer={true}
              />
            </div>
          ))}
      </Document>
      {numPages && (
        <div className="sticky bottom-0 bg-white py-2 px-4 border-t text-sm text-gray-600">
          {numPages} {numPages === 1 ? 'page' : 'pages'}
        </div>
      )}
    </div>
  );
};
